import { Modal as MuiModal } from '@material-ui/core';
import React from 'react';

import useStyles from 'components/Modal/Modal.styles';
import { useModal } from 'context/ModalProvider/ModalProvider';

const Modal = () => {
  const { showModal, setShowModal, modalContent } = useModal();
  const classes = useStyles();

  return (
    <MuiModal open={showModal} onClose={() => setShowModal(false)} className={classes.modal}>
      {modalContent}
    </MuiModal>
  );
};

export default Modal;
